/// <amd-module name="Test/common-util/FilterHelper" />
import { TestResultsOutcomeFilterPivots, FilterByFields } from "Test/common-util/Common";
import { FilterState, IFilter } from "Test/common-util/Contracts/Filters";
import { format, equals } from "VSS/Core/Util/String";
import { Constants } from "Test/common-util/Common";

export class FilterHelper {


    public static getInitialFilterState() {
        const initialFilterState: FilterState = {};
        let outcomeDefaultFilterValues: string[] = [];

        outcomeDefaultFilterValues.push(TestResultsOutcomeFilterPivots.Filter_By_Aborted);
        outcomeDefaultFilterValues.push(TestResultsOutcomeFilterPivots.Filter_By_Failed);
        initialFilterState[FilterByFields.Outcome] = {
            values: outcomeDefaultFilterValues
        };
        return initialFilterState;
    }

    public static generateFilterString(filterState: FilterState): string {
        let andFilterStrings: string[] = [];
        for (let filterType in filterState) {
            let selectedFilterValues: IFilter = filterState[filterType];
            if (selectedFilterValues.values.length) {

                let oDataString: string;
                // Sort the values so as to avoid sending request to server for every permutation
                selectedFilterValues.values.sort();

                switch (filterType) {
                    case FilterByFields.Outcome:
                        oDataString = "Outcome eq {0}";
                        let outcomes: string[] = selectedFilterValues.values.map((outcomeFilter: string) => this._getOutcomeFilterString(outcomeFilter));
                        andFilterStrings.push(format(oDataString, outcomes.join(",")));
                        break;
                    case FilterByFields.Owner:
                        oDataString = "Owner eq {0}";
                        let ownerValues = selectedFilterValues.values.join(",");
                        if (equals(ownerValues, "")) {
                            // Workaround when only unspecified owner is selected in owner filter
                            ownerValues = ",";
                        }
                        andFilterStrings.push(format(oDataString, ownerValues));
                        break;
                    case FilterByFields.Container:
                        oDataString = "AutomatedTestStorage eq {0}";
                        let containerValues = selectedFilterValues.values.join(",");
                        if (equals(containerValues, "")) {
                            // Workaround when only unspecified container is selected in container filter
                            containerValues = ",";
                        }
                        andFilterStrings.push(format(oDataString, containerValues));
                        break;
                }
            }


        }
        return andFilterStrings.join(" and ");
    }

    private static _getOutcomeFilterString(outcomeFilter: string): string {
        switch (outcomeFilter) {
            case TestResultsOutcomeFilterPivots.Filter_By_Others:
                return Constants.OTHER_OUTCOME_LIST.join(",");
            default:
                return outcomeFilter;
        }
    }

    public static getSearchText(filterState: FilterState): string | null {
        if (filterState && filterState.hasOwnProperty(FilterByFields.TestCaseName)) {
            let selectedSearchTexts: IFilter = filterState[FilterByFields.TestCaseName];
            if (selectedSearchTexts.values.length) {
                return selectedSearchTexts.values.join(",");
            }
        }
        return null;
    }

    public static isTagFilterEnabled(filterState: FilterState): boolean {
        if (filterState && filterState.hasOwnProperty(FilterByFields.Tags)) {
            return true;
        }
        return false;
    }

}
